<div class="discount-form" *ngIf="form">
    <form [formGroup]="form" class="flex-direction-column pb-0 row mx-3 py-5 px-3 mx-md-5">
        <div class="col-md-6">
            <div class="input-container fluid" *ngIf="discount.checkCondition('hasDirectDebit')">
                <p class="title no-margins">{{ "pt.edp.edponline.pack.discount.dd.title" | translate }}</p>
                <label>{{ "pt.edp.edponline.pack.discount.dd.label" | translate }}</label>
                <input type="text" class="form-control" placeholder="PT50 0000 0000 0000 0000 0000 0"
                    formControlName="iban" [ngClass]="{ error: form.controls.iban.invalid && isSubmited }" />
                <span class="error" *ngIf="form.controls.iban.hasError('required') && isSubmited">
                    {{ "pt.edp.edponline.form.requiredField" | translate }}
                </span>
                <span class="error" *ngIf="form.controls.iban.hasError('pattern') && isSubmited">
                    {{ "pt.edp.edponline.form.iban-invalid" | translate }}
                </span>
            </div>
        </div>
        <div class="col-md-6">
            <div class="input-container fluid" *ngIf="!discount.checkCondition('hasElectronicInvoice')">
                <p class="title no-margins">{{ "pt.edp.edponline.pack.discount.fp.title" | translate }}</p>
                <label>{{ "pt.edp.edponline.pack.discount.dd.address" | translate }}</label>
                <input type="text" class="form-control" formControlName="address" />
            </div>
            <div class="input-container fluid pl-0" *ngIf="discount.checkCondition('hasElectronicInvoice')">
                <p class="title no-margins">{{ "pt.edp.edponline.pack.discount.fe.title" | translate }}</p>
                <label>{{ "pt.edp.edponline.pack.discount.fe.label" | translate }}</label>
                <input type="email" class="form-control" formControlName="email"
                    [ngClass]="{ error: form.controls.email.invalid && isSubmited }" />
                <span class="error" *ngIf="form.controls.email.hasError('required') && isSubmited">
                    {{ "pt.edp.edponline.form.requiredField" | translate }}
                </span>
                <span class="error" *ngIf="form.controls.email.hasError('pattern') && isSubmited">
                    {{ "pt.edp.edponline.form.email-invalid" | translate }}
                </span>
            </div>
        </div>
    </form>
</div>